import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';
import { useLocalSearchParams } from 'expo-router';
import UpsideDetailsScreen from 'features/rewards/screens/CashbackHomeDetails/UpsideDetailsScreen';
import React from 'react';

export default function Page() {
  const { offerid, merchantId, lat, lng, autoActivate, categoryName } =
    useLocalSearchParams<{
      offerid: string;
      merchantId: string;
      lat?: string;
      lng?: string;
      autoActivate?: string;
      categoryName?: string;
    }>();

  const coordinates =
    lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng) } : undefined;

  return (
    <BottomSheetModalProvider>
      <UpsideDetailsScreen
        offerId={offerid}
        merchantId={merchantId}
        coordinates={coordinates}
        autoActivate={autoActivate === 'true'}
        categoryName={categoryName}
      />
    </BottomSheetModalProvider>
  );
}
